import React from "react";
import Footer from "../../comman/Footer";
import Header from "../../comman/Header";
import HomeHeroBanner from "../../component/HomeHeroBanner";
import home_background from "../../assets/image/FinalAboutUS.png";
import Image1 from "../../assets/image/img1.jpg";
import Image2 from "../../assets/image/img2.jpg";
import Image3 from "../../assets/image/img3.jpg";
import "./AboutUs.css";
function AboutUs() {
  return (
    <>
      <Header />
      <HomeHeroBanner Image={home_background} Text={``} />
      <section className="aboutus-flex-container center_container">
        <div className="aboutus-image-section">
          <img className="aboutus-image" src={Image3} alt="About Us" />
        </div>
        <div className="aboutus-content-section">
          <p className="first">
            Shree Umiya Toursim is a
            Gujarat based Travel and Tourism Company Having its office in 91, Hirabag Society
            Part 1, Near C. P. Nagar Cross Road, Ghatlodiya, Ahmedabad, Gujarat – India
          </p>
          <br/>
          <p>
            We are a team of professionals driven by a desire to change the whole landscape of Travel and
            Tourism in the region.
            We believe in innovation, not imitation and we ensure that all the ingredients of our tours
            are right-not just the price. Having the huge amount of enthusiasm, energy and commitment
            for Travel, we focus on stimulating your Travel experience. We offer unique range of
            Tourism products from General Tourism, Adventure Tourism, Film Tourism, Corporate
            Travel, and Incentive Tourism to Event Management.We are specialized in India Virgin
            Destinations so that our valuable guests will explore unexplored and untouched beauties of
            India
          </p>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default AboutUs;
